export function supportsObjectFit(): boolean {
  if (typeof document !== 'undefined') {
    return 'objectFit' in document.documentElement.style
  }

  return false
}
